<router-outlet></router-outlet>


<div  bsModal #childModal="bs-modal" class="modal fade" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" style="color: red;">Idle Time Limit</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hideChildModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>         you have not been active for more than 15 minutes. Do you wish to stop using EWP service ? you will be automatically logged out in 1 minutes</p>
        </div>
        <div class="modal-footer">
          <button type="button" style="color: white;" class="btn btn-secondary" (click)="logout()"> ({{idleState}})Logout</button>
          <button type="button" style="color: white;" class="btn btn-primary" (click)="stay()" data-dismiss="modal">Continue</button>
        </div>
      </div>
    </div>
  </div>
